import { useCallback, useEffect, useState } from "react";

import numeral from "numeral";
import { twMerge } from "tailwind-merge";
import { useToggle } from "usehooks-ts";

import ContentEditor from "components/ContentEditor";
import Modal from "components/Modal";
import useNotification from "components/Notification/useNotification";
import useAuthentication from "hooks/useAuthentication";
import { fetchApi } from "utils/baseFetcher";
import { emberAppBaseUrl } from "utils/envVariables";

import styles from "./styles.module.scss";

export const renderNumber = (value: number, record: any) => {
  const differential = record.differential;
  return (
    <div>
      {numeral(value).format("0,0.[00]")}{" "}
      <span
        className={twMerge(
          differential > 0
            ? "text-bullish-green"
            : differential === 0
            ? ""
            : "text-bearish-red"
        )}
      >
        ({differential > 0 ? "+" : ""}
        {differential})
      </span>
    </div>
  );
};

const PriceAssessmentModal = ({
  priceAssessment,
  onClose: onCloseProp,
  topContent,
}: {
  priceAssessment: any;
  onClose: (update: boolean) => void;
  topContent?: React.ReactNode;
}) => {
  console.log(priceAssessment);
  const [showEditor, toggleEditor] = useToggle(false);
  const [comment, setComment] = useState(priceAssessment.comment);
  const [updatedComment, setUpdatedComment] = useState(priceAssessment.comment);

  const { account: loggedInAccount } = useAuthentication();
  const { setNotification } = useNotification();

  const onClose = useCallback(() => {
    onCloseProp(updatedComment != priceAssessment.comment);
  }, []);

  const onCancel = useCallback(() => {
    setComment(updatedComment);
    toggleEditor();
  }, [updatedComment]);

  const onSave = useCallback(async () => {
    try {
      await fetchApi(
        `/api/v2/helixtap/price-assessments/${priceAssessment.id}`,
        {
          method: "PATCH",
          body: JSON.stringify({
            data: {
              id: priceAssessment.id,
              type: "price-assessments",
              attributes: {
                comment,
              },
            },
          }),
        }
      );
      setUpdatedComment(comment);
    } catch {
      setComment(updatedComment);
      setNotification("Something went wrong!", "error");
    }
    toggleEditor();
  }, [comment]);

  useEffect(() => {
    if (comment.includes("https://data.helixtap.com/price-signals/")) {
      setComment(
        comment.replace(
          /https:\/\/data.helixtap.com/,
          `${emberAppBaseUrl}/helixtap`
        )
      );
    }
  }, [comment]);

  return (
    <Modal onClose={onClose} className={styles.container}>
      <div className="px-[15px] py-[30px] space-y-[15px]">
        <div className="font-bold text-[16px]">
          {priceAssessment.comment_title}
        </div>
        {topContent}
        <div className="flex">
          <div className="flex-1"></div>
          {/* {loggedInAccount?.isInternalUser && !showEditor && (
            <button
              className={twMerge(
                "min-w-[6em] px-[15px] py-[8px]",
                "rounded-full border-0 bg-smart-teal hover:bg-smart-teal-500 text-white"
              )}
              onClick={toggleEditor}
            >
              <FontAwesomeIcon icon={faPencilAlt} /> Edit
            </button>
          )} */}
        </div>
        <div>
          {showEditor ? (
            <div className="space-y-[15px]">
              <ContentEditor value={comment} onInput={setComment} />
              <div className="flex justify-between w-full">
                <div>
                  <button
                    className={twMerge(
                      "min-w-[6em] px-[15px] py-[8px]",
                      "rounded-full border border-solid border-active-black bg-white hover:bg-active-black hover:text-white"
                    )}
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
                <div className="text-right">
                  <button
                    className={twMerge(
                      "min-w-[6em] px-[15px] py-[8px]",
                      "rounded-full border-0 bg-smart-teal hover:bg-smart-teal-500 text-white"
                    )}
                    onClick={onSave}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: comment }}></div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default PriceAssessmentModal;
